var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 347,
    viewBox: "0 0 560 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7025_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.052 198.222C200.803 198.222 245.188 154.171 245.188 99.8307C245.188 45.4908 200.803 1.43958 146.052 1.43958C91.3012 1.43958 46.9167 45.4908 46.9167 99.8307C46.9167 154.171 91.3012 198.222 146.052 198.222Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.791 210.732C167.448 210.732 209.325 205.086 209.325 198.123C209.325 191.159 167.448 185.513 115.791 185.513C64.1343 185.513 22.2579 191.159 22.2579 198.123C22.2579 205.086 64.1343 210.732 115.791 210.732Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.791 208.746C159.161 208.746 194.319 203.99 194.319 198.123C194.319 192.255 159.161 187.499 115.791 187.499C72.4215 187.499 37.2633 192.255 37.2633 198.123C37.2633 203.99 72.4215 208.746 115.791 208.746Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.449 347C496.626 347 560 338.443 560 327.888C560 317.332 496.626 308.775 418.449 308.775C340.273 308.775 276.899 317.332 276.899 327.888C276.899 338.443 340.273 347 418.449 347Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.383 310.761C276.399 322.179 362.93 295.868 372.433 266.083M133.398 128.623C133.398 128.623 173.712 110.405 176.163 169.082C178.614 227.759 143.001 244.439 170.911 256.105",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.489 279.586L385.538 304.556C385.538 304.556 366.131 314.782 379.786 315.08C393.441 315.378 457.663 315.08 457.663 315.08C457.663 315.08 470.068 315.08 450.411 304.258L446.459 278.096L389.489 279.586Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M377.035 314.832C380.136 312.101 385.538 309.222 385.538 309.222L389.489 284.252L446.459 284.302L450.411 308.924C455.013 311.456 457.864 313.392 459.514 314.881C462.065 314.286 464.816 312.201 450.411 304.258L446.459 278.096L389.489 279.586L385.538 304.556C385.538 304.556 369.232 313.144 377.035 314.832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.357 105.589H537.042C542.044 105.589 546.045 109.61 546.045 114.525V274.075C546.045 279.04 541.994 283.011 537.042 283.011H298.357C293.355 283.011 289.353 278.99 289.353 274.075V114.525C289.303 109.61 293.355 105.589 298.357 105.589Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.956 115.071H537.392V248.013H297.956V115.071Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.699 112.341C418.528 112.341 419.2 111.674 419.2 110.851C419.2 110.029 418.528 109.362 417.699 109.362C416.87 109.362 416.199 110.029 416.199 110.851C416.199 111.674 416.87 112.341 417.699 112.341Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.045 258.537V274.075C546.045 279.04 541.994 283.011 537.042 283.011H298.357C293.355 283.011 289.353 278.99 289.353 274.075V258.537H546.045ZM484.673 331.363V334.341H321.615V331.958L321.815 331.363L325.866 320.541H481.322L484.673 331.363ZM547.396 328.384C547.095 329.625 545.995 330.966 543.444 332.256C534.341 336.774 515.884 331.065 515.884 331.065C515.884 331.065 501.629 328.682 501.629 322.328C502.029 322.08 502.429 321.831 502.88 321.583C506.681 319.597 519.386 314.633 541.844 321.782C543.494 322.278 544.995 323.271 546.095 324.562C547.045 325.654 547.746 326.994 547.396 328.384Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M547.396 328.384C536.242 332.604 526.338 332.951 516.184 325.902C511.033 322.377 506.381 321.484 502.88 321.533C506.681 319.548 519.386 314.584 541.844 321.732C543.494 322.228 544.995 323.221 546.095 324.512C547.045 325.654 547.746 326.994 547.396 328.384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.441 325.902C535.623 325.902 537.392 325.369 537.392 324.711C537.392 324.053 535.623 323.519 533.441 323.519C531.258 323.519 529.489 324.053 529.489 324.711C529.489 325.369 531.258 325.902 533.441 325.902Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.699 276.607C420.876 276.607 423.451 274.051 423.451 270.898C423.451 267.745 420.876 265.189 417.699 265.189C414.522 265.189 411.947 267.745 411.947 270.898C411.947 274.051 414.522 276.607 417.699 276.607Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M484.673 331.363V334.341H321.615V331.958L321.815 331.363H484.673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9167 10.6234H133.748V197.03H46.9167V10.6234Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9203 18.7648H123.744V38.3239H56.9203V18.7648Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6353 30.9272H81.9793C81.7792 30.9272 81.5792 30.7286 81.5792 30.5301V26.6083C81.5792 26.4098 81.7792 26.2112 81.9793 26.2112H98.6353C98.8353 26.2112 99.0354 26.4098 99.0354 26.6083V30.5301C99.0354 30.7286 98.8853 30.9272 98.6353 30.9272Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9203 43.6356H123.744V63.1947H56.9203V43.6356Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6353 55.7981H81.9793C81.7792 55.7981 81.5792 55.5995 81.5792 55.4009V51.4792C81.5792 51.2806 81.7792 51.082 81.9793 51.082H98.6353C98.8353 51.082 99.0354 51.2806 99.0354 51.4792V55.4009C99.0354 55.5995 98.8853 55.7981 98.6353 55.7981Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9203 68.5065H123.744V88.0655H56.9203V68.5065Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6353 80.6688H81.9793C81.7792 80.6688 81.5792 80.4702 81.5792 80.2716V76.3499C81.5792 76.1513 81.7792 75.9528 81.9793 75.9528H98.6353C98.8353 75.9528 99.0354 76.1513 99.0354 76.3499V80.2716C99.0354 80.4702 98.8853 80.6688 98.6353 80.6688Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9203 93.675H123.744V189.485H56.9203V93.675Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6353 105.788H81.9793C81.7792 105.788 81.5792 105.589 81.5792 105.391V101.469C81.5792 101.27 81.7792 101.072 81.9793 101.072H98.6353C98.8353 101.072 99.0354 101.27 99.0354 101.469V105.391C99.0354 105.639 98.8853 105.788 98.6353 105.788Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.281 335.781C227.281 338.908 216.177 341.639 200.021 342.929C193.269 343.475 185.616 343.823 177.463 343.823C169.36 343.823 161.708 343.525 154.905 342.929C138.7 341.589 127.646 338.908 127.646 335.781C127.646 332.653 138.75 329.923 154.905 328.583C161.658 328.037 169.31 327.689 177.463 327.689C185.566 327.689 193.219 327.987 200.021 328.583C216.177 329.973 227.281 332.653 227.281 335.781Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.971 317.314V342.979C193.219 343.525 185.566 343.873 177.413 343.873C169.311 343.873 161.658 343.575 154.855 342.979V317.314C154.855 304.953 164.959 294.925 177.413 294.925C183.616 294.925 189.268 297.407 193.369 301.478C197.471 305.549 199.971 311.109 199.971 317.314Z",
    fill: "url(#paint0_linear_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.217 327.739C190.062 327.739 192.369 325.45 192.369 322.626C192.369 319.802 190.062 317.512 187.217 317.512C184.372 317.512 182.065 319.802 182.065 322.626C182.065 325.45 184.372 327.739 187.217 327.739Z",
    fill: "url(#paint1_radial_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.217 324.76C188.018 324.76 188.667 324.116 188.667 323.321C188.667 322.526 188.018 321.881 187.217 321.881C186.416 321.881 185.766 322.526 185.766 323.321C185.766 324.116 186.416 324.76 187.217 324.76Z",
    fill: "url(#paint2_linear_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71 327.739C170.555 327.739 172.862 325.45 172.862 322.626C172.862 319.802 170.555 317.512 167.71 317.512C164.865 317.512 162.558 319.802 162.558 322.626C162.558 325.45 164.865 327.739 167.71 327.739Z",
    fill: "url(#paint3_radial_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71 325.505C168.511 325.505 169.16 324.86 169.16 324.065C169.16 323.27 168.511 322.626 167.71 322.626C166.909 322.626 166.259 323.27 166.259 324.065C166.259 324.86 166.909 325.505 167.71 325.505Z",
    fill: "url(#paint4_linear_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.976 303.166L141.1 325.257L141.4 307.584L141.601 296.563L141.651 292.542L142.001 272.735L142.251 257.693L142.551 239.375C142.551 237.936 143.501 236.695 144.902 236.298L157.756 232.326C159.107 231.879 160.607 232.376 161.458 233.567L172.261 248.46L181.115 260.672L192.769 276.756L195.17 280.032L201.672 288.968L211.976 303.166ZM226.431 304.953L130.347 334.887C128.746 335.384 127.095 334.49 126.595 332.951C126.095 331.363 126.995 329.724 128.546 329.228L224.63 299.294C226.231 298.797 227.881 299.691 228.382 301.23C228.882 302.769 227.981 304.456 226.431 304.953Z",
    fill: "#FFD300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.065 260.573L142.001 272.735L142.251 257.693L172.212 248.361L181.065 260.573Z",
    fill: "url(#paint5_linear_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.572 288.819L141.401 307.584L141.651 292.542L192.719 276.607L201.572 288.819Z",
    fill: "url(#paint6_linear_7025_41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.976 303.166L141.1 325.257L141.401 307.584L141.601 296.563L195.12 279.884L201.572 288.819L211.976 303.166Z",
    fill: "url(#paint7_linear_7025_41)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7025_41",
    x1: 160.823,
    y1: 340.388,
    x2: 201.161,
    y2: 302.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7025_41",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.74 321.367) scale(7.59121 7.53423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#D4D5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C2C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#AAAEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7025_41",
    x1: 185.761,
    y1: 323.321,
    x2: 188.656,
    y2: 323.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7025_41",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.243 321.367) scale(7.59121 7.53423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#D4D5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C2C4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#AAAEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7025_41",
    x1: 166.264,
    y1: 324.065,
    x2: 169.159,
    y2: 324.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#242934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7025_41",
    x1: 142.185,
    y1: 276.159,
    x2: 175.95,
    y2: 246.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#B8BDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#D7DAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#EDEEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7025_41",
    x1: 139.246,
    y1: 300.766,
    x2: 199.344,
    y2: 281.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BAC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#CDD1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#E3E5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7025_41",
    x1: 178.765,
    y1: 321.247,
    x2: 172.721,
    y2: 301.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D6C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#AC9487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#C9BAB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#E1D8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#F1EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7025_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 347,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error-image.6cc3dc66364e4668559be925de96df69.svg";
export { ForwardRef as ReactComponent };